import { useTranslation } from 'react-i18next';

import { OrganisationTeamRole } from '../__generated__/types';

export const useGetRole = () => {
	const { t } = useTranslation();

	const getPalRoleString = (userRole: string, organisationRole: string) => {
		if (userRole !== 'PAL') {
			return '';
		}

		if (organisationRole === 'MANAGER') {
			return t('roles.manager');
		}

		return t('roles.member');
	};

	const getRoleString = (userRole: string, organisationRole: string) => {
		if (userRole === 'USER') {
			return t('roles.care-recipient');
		}

		return getPalRoleString(userRole, organisationRole);
	};

	const getTeamRoleString = (userRole: string, teamRole: OrganisationTeamRole) => {
		if (teamRole === OrganisationTeamRole.Admin) {
			return t('roles.team-admin');
		}

		return getRoleString(userRole, '');
	};

	return { getRoleString, getTeamRoleString };
};
